module.exports = __webpack_public_path__ + "Server-Unhealthy-TentacleActive.3e9cbe29afb016e290193fa6fe0edabc.hashedasset.svg";